import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { Store } from '@ngrx/store';
import { AppState } from '@state/app.state';
import { selectConfigOpenModal } from '@state/config/config.selectors';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-home-map-list-switcher',
  templateUrl: './switcher.component.html',
  styleUrls: ['./switcher.component.scss'],
})
export class SwitcherComponent implements OnInit {
  @Input() isMapView = true;
  @Output() switchMapView = new EventEmitter<void>();

  protected openModal?: string;
  public deviceOrientation = screen?.orientation?.type || 'portrait-primary';

  constructor(
    private store: Store<AppState>,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.store
      .select(selectConfigOpenModal)
      .pipe(untilDestroyed(this))
      .subscribe((openModal) => {
        this.openModal = openModal;
        this.changeDetectorRef.detectChanges();
      });
  }

  handleSwitchMapView(): void {
    this.switchMapView.emit();
  }

  @HostListener('window:orientationchange', ['$event'])
  onOrientationChange(): void {
    this.deviceOrientation = screen?.orientation?.type || 'portrait-primary';
  }
}
